<template lang="pug">
  .courier-selection
    .courier-header.custom-control.custom-checkbox--courier(:class="{ 'courier-header--alone': !hasBody() }")
      input.custom-control-input(:id='labelFor' v-if="!disabled" @change="$emit('change', $event.target.value)"
      type='radio' :value='value' :checked="model === value" :name='name')
      template(v-if="disabled") 
        label {{ label }}
      label.custom-control-label.custom-control-label--courier(:for='labelFor' v-else)
        | {{ label }}
      span.header-label(v-if="!disabled") {{ headerLabel }}
    .courier-body(v-if="hasBody()")
      slot
</template>

<script>
// TODO change class name

export default {
  name: 'RadioCard',
  model: {
    prop: 'model',
    event: 'change',
  },
  props: ['headerLabel', 'label', 'model', 'value', 'name', 'disabled'],
  data() {
    return {
      labelFor: Math.random().toString(36).substr(2, 5),
    };
  },
  methods: {
    // DP-5140: an option with nothing under it (Australia Post, since its
    // "Schedule" note was removed) shows just its header line instead of an
    // empty 120px box. A method, not a computed: $slots is not reactive.
    hasBody() {
      return (this.$slots.default || []).some(
        vnode => vnode.tag || (vnode.text || '').trim(),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.lh-md {
  line-height: 22px;
}

.courier-selection {
  background-color: $gray-125;
  border-radius: 4px;
  margin-bottom: 18px;
}

.courier-header {
  border-bottom: solid 1px #dce0e6;
  height: 64px;
  padding: 20px 24px;

  label {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 25px;
    letter-spacing: normal;
    color: $gray-950;
  }
}

.header-label {
  position: absolute;
  right: 24px;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 25px;
  letter-spacing: normal;
  color: $gray-950;
}

.courier-body {
  min-height: 120px;
  padding: 24px;
}

// DP-5140: no divider under the header when there is no body below it.
.courier-header--alone {
  border-bottom: 0;
}

.custom-control-label--courier {
  left: 42px;

  &::before,
  &::after {
    top: 0;
    left: -42px;
  }
}
</style>
